import bridge from '../bridge/index'
import env from '../core/env'
import { noop } from '../util/lang'

function getSystemInfo (success = noop, fail = noop) {
  bridge.getSystemInfo({}, function (res) {
    success(res)
  })
}

function setTitle (title = '', success = noop) {
  const key = env.is('passenger') ? 'navi_title' : 'vctitle'
  bridge.setTitle({ [key]: title }, success)
}

export default {
  getSystemInfo,
  setTitle
}
